import { Link, useParams } from 'react-router-dom';
import { t, getal } from '../i18n.js';
import { groepenVoor, useMenuTellers } from '../menu.js';
import { ICOON } from '../components/iconen.jsx';

/**
 * Een groepspagina, zoals de domeinpagina in ADTS-ONE: de onderliggende schermen van een groep
 * (Monitoring, Compliance, …) als tegels met een icoon en de naam. Waar we het aantal goedkoop weten
 * (nieuwe alerts, wachtende blokkades) staat het als cijfer op de tegel, met een regel eronder.
 */
const FEIT = { alerts: 'nieuw', blokkades: 'wacht op goedkeuring' };

export default function Groep({ gekozen, mag }) {
  const { id } = useParams();
  const tellers = useMenuTellers(mag, gekozen);
  const g = groepenVoor(mag).find((x) => x.id === id);
  if (!g) return <div className="page-head"><div><h1>{t('Niet gevonden')}</h1></div></div>;
  return (
    <>
      <div className="page-head">
        <div>
          <h1>{t(g.titel)}</h1>
          <p className="sub">{t('{n} objecten', { n: g.items.length })}</p>
        </div>
      </div>
      <div className="tegelgrid">
        {g.items.map((i) => {
          const n = i.teller ? tellers[i.teller] : null;
          return (
            <Link key={i.pad} className="tegel" to={i.pad}>
              <span className="tegelkop">
                <span className="tegelicoon">{ICOON[i.icoon] ?? ICOON.boek}</span>
                <span className="tegelnaam">{t(i.label)}</span>
              </span>
              {n !== null && <>
                <span className="tegelcijfer num">{getal(n)}</span>
                <span className="tegelfeiten"><span className={n > 0 ? 'let' : undefined}>{t(FEIT[i.teller])}</span></span>
              </>}
            </Link>
          );
        })}
      </div>
    </>
  );
}
